
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tcpip",
      function () {
        return require("private-next-pages/tcpip.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tcpip"])
      });
    }
  